import React, { useState } from 'react';
import CircleButton, { getCircleButtonClass, } from 'components/v2/buttons/CircleButton';
import UserIcon from 'components/v2/icons/UserIcon';
import CheckIcon from 'components/v2/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import SessionStore from 'stores/SessionStore';
import AssignDriverModal from 'components/modules/shipments/AssignDriverModal';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
export default function AssignCarrierNextStep({ item, shipment }) {
    if (SessionStore.isCarrier())
        return null;
    const { t } = useTranslation();
    const [showAssignModal, setShowAssignModal] = useState(false);
    const renderIcon = () => {
        return !item.complete ? (React.createElement(UserIcon, { type: "solid", className: "w-5 h-5" })) : (React.createElement("div", { "data-testid": "div-234c3b3a", className: getCircleButtonClass({ size: 'small', color: 'brand' }) },
            React.createElement(CheckIcon, null)));
    };
    return ((React.createElement("div", { "data-testid": "div-52059406" },
        React.createElement("div", { "data-testid": "div-47aaf399", className: "flex justify-between text-sm text-gray-700  py-1 items-center" },
            React.createElement("span", { "data-testid": "span-345f8957" }, t('ASSIGN_CARRIER')),
            React.createElement(CircleButton, { dataTestId: "CircleButton-ea62d2e9", size: "small", disabled: item.complete, onClick: () => setShowAssignModal(true) }, renderIcon())),
        React.createElement(AssignDriverModal, { shipments: [], shipment: shipment, show: showAssignModal, onAssignDriver: ShipmentsActionCreators.assignDriver, onHide: () => setShowAssignModal(false) }))));
}
